import React from 'react'
import { useMedia } from 'sb-hooks'

import { Row } from 'components/_new/layout'

import Tag from '../Tag/Tag'

import s from './TagList.scss'


type TagListProps = {
  items: Review.Tag[]
  onVote: (tagId: number) => void
}

const TagList: React.FunctionComponent<TagListProps> = ({ items, onVote }) => {
  const { isMobile } = useMedia()

  return (
    <Row
      justify={isMobile ? 'center' : 'start'}
      align="start"
      wrap
    >
      {
        items.map(({ id, name, image }) => (
          <div key={id} className={s.tag}>
            <Tag
              id={id}
              name={name}
              image={image}
              onClick={onVote}
            />
          </div>
        ))
      }
    </Row>
  )
}


export default TagList
